import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000'
    },
    hsv: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 152
    }
  },
  data: function data() {
    return {
      slideSaturationStyle: {}
    };
  },

  // 不能监听，否则自己改变自己时，颜色也会发生变化
  // watch: {
  //     color() {
  //         this.renderColor()
  //     }
  // },
  mounted: function mounted() {
    this.renderColor();
    this.renderSlide();
  },

  methods: {
    renderColor: function renderColor() {
      var canvas = this.$refs.canvasSaturation;
      var size = this.size;
      var ctx = canvas.getContext('2d');
      canvas.width = size;
      canvas.height = size;

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, size, size);

      this.createLinearGradient('l', ctx, size, size, '#FFFFFF', 'rgba(255,255,255,0)');
      this.createLinearGradient('p', ctx, size, size, 'rgba(0,0,0,0)', '#000000');
    },
    renderSlide: function renderSlide() {
      this.slideSaturationStyle = {
        left: this.hsv.s * this.size - 5 + 'px',
        top: (1 - this.hsv.v) * this.size - 5 + 'px'
      };
    },
    selectSaturation: function selectSaturation(e) {
      var _this = this;

      var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
          saturationTop = _$el$getBoundingClien.top,
          saturationLeft = _$el$getBoundingClien.left;

      var ctx = e.target.getContext('2d');

      var mousemove = function mousemove(e) {
        var x = e.clientX - saturationLeft;
        var y = e.clientY - saturationTop;

        if (x < 0) {
          x = 0;
        }
        if (y < 0) {
          y = 0;
        }
        if (x > _this.size) {
          x = _this.size;
        }
        if (y > _this.size) {
          y = _this.size;
        }

        // 不通过监听数据变化来修改dom，否则当颜色为#ffffff时，slide会跑到左下角
        _this.slideSaturationStyle = {
          left: x - 5 + 'px',
          top: y - 5 + 'px'
          // 如果用最大值，选择的像素会是空的，空的默认是黑色
        };var imgData = ctx.getImageData(Math.min(x, _this.size - 1), Math.min(y, _this.size - 1), 1, 1);

        var _imgData$data = _slicedToArray(imgData.data, 3),
            r = _imgData$data[0],
            g = _imgData$data[1],
            b = _imgData$data[2];

        _this.$emit('selectSaturation', { r: r, g: g, b: b });
      };

      mousemove(e);

      var mouseup = function mouseup() {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    }
  }
};